import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import GlobalStyles from './styles/GlobalStyles';
import LoadingScreen from './components/LoadingScreen';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Catalog from './pages/Catalog';
import Contact from './pages/Contact';
import AddProduct from './pages/AddProduct';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <GlobalStyles />
      <AnimatePresence>
        {loading && <LoadingScreen onLoadingComplete={() => setLoading(false)} />}
      </AnimatePresence>
      
      {!loading && (
        <>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/addproduct" element={<AddProduct />} />
          </Routes>
          <Footer />
           <WhatsAppButton />
        </>
      )}
    </>
  );
}

export default App;